<template>
  <div class="flow-object-detail">
    <div
      v-if="!hideHeader"
      class="bg-white border-bottom"
    >
      <div class="container-xl">
        <div class="row">
          <div class="col-12 min-height-130 d-flex flex-column justify-content-center">
            <!-- we have min-height to avoid jumping when things are loading -->
            <transition
              name="fade-faster"
              mode="out-in"
            >
              <div
                v-if="loadingNodes && !headerNodes.length"
                key="headerLoading"
                class="my-3"
              >
                <b-skeleton
                  key="titleLoading"
                  width="400px"
                  height="2rem"
                ></b-skeleton>
              </div>
              <div
                v-else
                key="headerLoaded"
                class="flow-object-detail-headers-wrapper"
              >
                <div
                  v-for="hNode in headerNodes"
                  :key="hNode.key"
                  v-html="hNode.content"
                  class="flow-object-detail-single-header-outer"
                ></div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div class="container-xl">
      <div class="row py-4">
        <div
          v-if="!hideTabs"
          :class="`col-12 col-lg-${tabCols}`"
        >
          <!-- LEFT SIDE NAV -->

          <div
            class="row sticky-top"
            style="top: 1rem"
          >
            <div class="col-12 mb-4">
              <b-list-group class="flow-object-tabs shadow-sm">
                <b-list-group-item
                  class="flow-object-tab-item p-0 d-flex justify-content-start align-items-stretch"
                  button
                  :active="summaryTabKey === activeTab"
                  @click="handleSummaryClick"
                >
                  <div class="tab-icon px-3 d-flex align-items-center justify-content-center">
                    <b-icon
                      icon="house-fill"
                      :variant="summaryTabKey === activeTab ? 'primary' : 'secondary'"
                      class="rounded-circle bg-secondary-100"
                      style="padding: 6px"
                      font-scale="2"
                    ></b-icon>
                    <!-- <b-icon icon="house" variant="primary" class="" style="" font-scale="2"></b-icon> -->
                  </div>
                  <div class="tab-text w-100 py-75 pr-3">
                    <div class="text-dark font-weight-500">{{ finalSummaryTabName }}</div>
                    <!-- <div class="small text-muted">View summary page</div> -->
                  </div>
                </b-list-group-item>
                <b-list-group-item
                  v-if="enableHistory"
                  class="flow-object-tab-item p-0 d-flex justify-content-start align-items-stretch"
                  button
                  :active="historyTabKey === activeTab"
                  @click="handleHistoryClick"
                >
                  <div class="tab-icon px-3 d-flex align-items-center justify-content-center">
                    <b-icon
                      icon="calendar2-week-fill"
                      :variant="historyTabKey === activeTab ? 'primary' : 'secondary'"
                      class="rounded-circle bg-secondary-100"
                      style="padding: 6px"
                      font-scale="2"
                    ></b-icon>
                    <!-- <b-icon icon="calendar2-week-fill" variant="primary" class="" style="" font-scale="2"></b-icon> -->
                  </div>
                  <div class="tab-text w-100 py-75 pr-3">
                    <div class="text-dark font-weight-500">{{ finalHistoryTabName }}</div>
                    <!-- <div class="small text-muted">View event history</div> -->
                  </div>
                </b-list-group-item>
                <b-list-group-item
                  v-if="enableMessages"
                  class="flow-object-tab-item p-0 d-flex justify-content-start align-items-stretch"
                  button
                  :active="messagesTabKey === activeTab"
                  @click="handleMessagesClick"
                >
                  <div class="tab-icon px-3 d-flex align-items-center justify-content-center">
                    <b-icon
                      icon="chat-quote-fill"
                      :variant="messagesTabKey === activeTab ? 'primary' : 'secondary'"
                      class="rounded-circle bg-secondary-100"
                      style="padding: 6px"
                      font-scale="2"
                    ></b-icon>
                    <!-- <b-icon icon="chat-quote-fill" variant="primary" class="" style="" font-scale="2"></b-icon> -->
                  </div>
                  <div class="tab-text w-100 py-75 pr-3">
                    <div class="text-dark font-weight-500 d-flex align-items-baseline justify-content-between">
                      <span>{{ finalMessagesTabName }}</span>
                      <b-badge
                        v-if="hasUnreadMessages"
                        variant="danger"
                        class="ml-auto text-uppercase"
                        >New</b-badge
                      >
                    </div>
                    <!-- <div class="small text-muted">Message with others</div> -->
                  </div>
                </b-list-group-item>
                <b-list-group-item
                  v-if="enableAiAgentTab"
                  class="flow-object-tab-item p-0 d-flex justify-content-start align-items-stretch"
                  button
                  :active="aiAgentTabKey === activeTab"
                  @click="handleAiAgentTabClick"
                >
                  <div class="tab-icon px-3 d-flex align-items-center justify-content-center">
                    <AiIcon
                      class="rounded-circle bg-secondary-100"
                      :class="aiAgentTabKey === activeTab ? 'text-primary' : 'text-secondary'"
                      :style="{padding: '4px', fontSize: '2em'}"
                    ></AiIcon>
                  </div>
                  <div class="tab-text w-100 py-75 pr-3">
                    <div class="text-dark font-weight-500 d-flex align-items-baseline justify-content-between">
                      <span>AI Assistant</span>
                    </div>
                  </div>
                </b-list-group-item>

                <!-- CUSTOM TABS -->
                <b-list-group-item
                  v-for="customTab in customTabRegistry"
                  :key="customTab.name"
                  class="flow-object-tab-item p-0 d-flex justify-content-start align-items-stretch"
                  button
                  :active="customTab.name === activeTab"
                  @click="handleCustomTabClick(customTab.name)"
                >
                  <div class="tab-icon px-3 d-flex align-items-center justify-content-center">
                    <b-icon
                      :icon="customTab.icon ? customTab.icon : 'record-fill'"
                      :variant="customTab.name === activeTab ? 'primary' : 'secondary'"
                      class="rounded-circle bg-secondary-100"
                      style="padding: 6px"
                      font-scale="2"
                    ></b-icon>
                    <!-- <b-icon icon="chat-quote-fill" variant="primary" class="" style="" font-scale="2"></b-icon> -->
                  </div>
                  <div class="tab-text w-100 py-75 pr-3">
                    <div class="text-dark font-weight-500 d-flex align-items-baseline justify-content-between">
                      <span>{{ customTab.title }}</span>
                    </div>
                    <!-- <div class="small text-muted">Message with others</div> -->
                  </div>
                </b-list-group-item>
              </b-list-group>
              <!-- <b-link @click="refresh">Refresh</b-link> -->
            </div>

            <div
              v-if="taskNodes.length"
              class="col-12 col-lg-12 mb-4"
              :class="allActions.length ? 'col-md-6' : ''"
            >
              <!-- TASK GROUP VERSION -->
              <div
                v-for="taskNodeGroup in taskNodeGroups"
                :key="taskNodeGroup.key"
                class="task-node-group"
                :class="[`task-node-group-${taskNodeGroup.key}`]"
              >
                <div class="font-weight-600 font-size-100">{{ taskNodeGroup.label }}</div>
                <b-list-group class="flow-object-tabs shadow-sm">
                  <b-list-group-item
                    v-for="task in taskNodeGroup.nodes"
                    :key="task.key"
                    class="flow-object-tab-item p-0 d-flex justify-content-start align-items-stretch"
                    button
                    :active="task.key === activeTab"
                    @click="handleNodeClick(task)"
                  >
                    <div class="tab-icon px-3 d-flex align-items-center justify-content-center">
                      <!-- style="border-left: 4px solid var(--primary);" -->
                      <b-icon
                        :id="`task-icon-${task.key}`"
                        :icon="task.iconData.icon"
                        :variant="task.iconData.variant"
                        class="rounded-circle"
                        :class="task.iconData.class"
                        style="padding: 6px"
                        font-scale="2"
                        v-b-tooltip="{ title: task.iconData.tooltip, placement: 'left', id: `task-icon-${task.key}`, delay: { show: 500, hide: 100 } }"
                      ></b-icon>
                    </div>
                    <div class="tab-text w-100 py-75 pr-3">
                      <div class="text-dark font-weight-500">{{ task.title }}</div>
                      <div
                        v-if="!taskNodeGroup.condensed"
                        class="small text-muted"
                        >{{ task.description }}</div
                      >
                    </div>
                    <div
                      v-if="task.showIsAssignedTu"
                      class="is-assigned-tu-badge special-task-assignee-badge shadow-sm"
                      >You</div
                    >
                    <div
                      v-if="task.showSupplierTaskBadge"
                      class="supplier-flow-task-badge special-task-assignee-badge shadow-sm"
                      >Supplier</div
                    >
                  </b-list-group-item>
                </b-list-group>
              </div>

              <!-- for md - if you have nodes, these will be side-by-side -->
              <!-- <div class="font-weight-600 font-size-100">Tasks</div>
              <b-list-group class="flow-object-tabs shadow-sm">
                <b-list-group-item
                  v-for="task in taskNodes"
                  :key="task.key"
                  class="flow-object-tab-item p-0 d-flex justify-content-start align-items-stretch"
                  button
                  :active="task.key === activeTab"
                  @click="handleNodeClick(task)"
                >
                  <div class="tab-icon px-3 d-flex align-items-center justify-content-center">
                    <b-icon
                      :icon="task.iconData.icon"
                      :variant="task.iconData.variant"
                      class="rounded-circle"
                      :class="task.iconData.class"
                      style="padding: 6px"
                      font-scale="2"
                    ></b-icon>
                  </div>
                  <div class="tab-text w-100 py-75 pr-3">
                    <div class="text-dark font-weight-500">{{ task.title }}</div>
                    <div class="small text-muted">{{ task.description }}</div>
                  </div>
                  <div
                    v-if="task.showIsAssignedTu"
                    class="is-assigned-tu-badge special-task-assignee-badge shadow-sm"
                    >You</div
                  >
                  <div
                    v-if="task.showSupplierTaskBadge"
                    class="supplier-flow-task-badge special-task-assignee-badge shadow-sm"
                    >Supplier</div
                  >
                </b-list-group-item>
              </b-list-group> -->
            </div>

            <!-- PUT SLOT? HERE TO SHOW OTHER ZONES?  PPAP, etc. -->

            <div
              v-if="allActions.length"
              class="col-12 col-lg-12 mb-4"
              :class="taskNodes.length ? 'col-md-6' : ''"
            >
              <!-- for md - if you have nodes, these will be side-by-side -->
              <div class="font-weight-600 font-size-100">{{ actionsLabel }}</div>
              <b-list-group class="flow-object-tabs shadow-sm">
                <b-list-group-item
                  v-for="action in allActions"
                  :key="action.key"
                  class="flow-object-tab-item p-0 d-flex justify-content-start align-items-stretch"
                  button
                  :active="action.key === activeTab"
                  @click="handleActionClick(action)"
                >
                  <div class="tab-icon px-3 d-flex align-items-center justify-content-center">
                    <!-- style="border-left: 4px solid var(--primary);" -->
                    <b-icon
                      :icon="action.icon"
                      :variant="action.color_variant"
                      class="rounded-circle"
                      :class="`bg-${action.color_variant}-100`"
                      style="padding: 6px"
                      font-scale="2"
                    ></b-icon>
                  </div>
                  <div class="tab-text py-75 pr-3">
                    <div class="text-dark font-weight-500">{{ action.title }}</div>
                    <div 
                      v-if="!condensedTasks"
                      class="small text-muted">{{ action.description }}</div>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </div>

            <div class="col-12 mb-3">
              <b-button
                variant="gray-primary"
                :disabled="isManualRefreshing"
                @click="manualRefresh"
              >
                <b-icon
                  icon="arrow-repeat"
                  :animation="isManualRefreshing ? 'spin' : ''"
                  class="mr-2"
                ></b-icon>
                Refresh
              </b-button>
            </div>
          </div>

          <div
            v-if="$currentUserInfo.user_is_staff"
            class="my-3"
          >
            <!-- SUPPLIOS STAFF BUTTONS -->
            <!-- <b-button 
                              v-b-toggle.event-history-sidebar 
                              variant="gray-primary"
                          >
                              Show Event History
                          </b-button> -->
          </div>
        </div>

        <!-- <div class="col-12 col-lg-9"> -->
        <div :class="`col-12 col-lg-${detailCols}`">
          <!-- MAIN CONTENT AREA -->

          <b-alert
            :show="!!errorHandlingMessage"
            variant="danger"
            dismissible
            >{{ errorHandlingMessage }}</b-alert
          >

          <!-- <div
                          v-if="customTabNames.includes(activeTab)"
                          :key="`custom-tab-${activeTab}`"
                      > -->
          <div>
            <slot name="customtabs"></slot>
          </div>

          <transition
            name="flow-object-active-node-trans"
            mode="out-in"
          >
            <div
              v-if="activeTab === summaryTabKey"
              key="summaryPage"
              class="row"
            >
              <div class="col-12">
                <slot name="summarytop"></slot>
              </div>

              <div class="col-12">
                <div
                  v-for="dNode in summaryNodes"
                  :key="dNode.key"
                  class=""
                >
                  <FlowNode
                    :flowObjectClass="flowObjectClass"
                    :flowSubtype="flowSubtype"
                    :flowObjectId="flowObjectId"
                    :nodeKey="dNode.key"
                    :nodeData="dNode"
                    :flowContext="flowContext"
                  ></FlowNode>
                  <!-- no @events on display nodes? -->
                </div>
              </div>

              <div class="col-12">
                <!-- Related Issues - only show IF you have them -->
                <div
                  v-if="relatedIssues && relatedIssues.length"
                  class="mb-4 shadow-sm border rounded-lg bg-white p-125"
                >
                  <h4 class="font-weight-bold text-primary-darker mb-0"> Related Items </h4>
                  <hr class="bg-gray-400" />
                  <div class="">
                    <!-- make a table with local pagination.... so it isn't too long - and maybe only get limited fields -->
                    <b-table
                      :items="relatedIssues"
                      :fields="relatedIssuesFields"
                      :current-page="relatedIssuesCurrentPage"
                      :per-page="relatedIssuesPerPage"
                      primary-key="id"
                      stacked="md"
                      show-empty
                      small
                      class="no-top-border"
                    >
                      <template #cell(title)="slotProps">
                        <a
                          :href="slotProps.item.permalink_url"
                          target="_blank"
                          class="font-weight-bold"
                          >{{ slotProps.value }}</a
                        >
                      </template>
                      <template #cell(current_state_def)="slotProps">
                        <FlowObjectStateBadge v-bind="slotProps.value"></FlowObjectStateBadge>
                      </template>
                    </b-table>
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="font-weight-bold text-muted">{{ relatedIssues.length }} {{ relatedIssues.length > 1 ? 'Items' : 'Item' }}</span>
                      <b-pagination
                        v-if="relatedIssues.length > relatedIssuesPerPage"
                        v-model="relatedIssuesCurrentPage"
                        :total-rows="relatedIssues.length"
                        :per-page="relatedIssuesPerPage"
                        size="sm"
                        class="my-0"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-md-6"
                v-if="!hideTeam"
                key="teamSection"
              >
                <div class="mb-5 shadow-sm border rounded-lg bg-white p-125">
                  <!-- <h4 class="font-weight-bold text-primary-darker mb-0"> Team </h4>
                  <hr class="bg-gray-400" /> -->
                  <!-- moved inside component so we can override the title -->
                  <FlowObjectTeamList
                    :flowObjectClass="flowObjectClass"
                    :flowSubtype="flowSubtype"
                    :flowObjectId="flowObjectId"
                    :flowContext="flowContext"
                    :teamManagerKey="teamManagerKey"
                  ></FlowObjectTeamList>
                </div>
              </div>

              <div
                class="col-md-6"
                v-if="!hideFiles"
                key="filesSection"
              >
                <div class="mb-5 shadow-sm border rounded-lg bg-white p-125">
                  <FlowObjectFileList
                    ref="fileList"
                    :flowObjectClass="flowObjectClass"
                    :flowSubtype="flowSubtype"
                    :flowObjectId="flowObjectId"
                    :fileManagerKey="fileManagerKey"
                  ></FlowObjectFileList>
                </div>
              </div>

              <div class="col-12">
                <slot name="summarybottom"></slot>
              </div>
            </div>

            <div
              v-else-if="activeTab === historyTabKey && enableHistory"
              key="historyTab"
              class=""
            >
              <div class="mb-5 shadow-sm border rounded-lg bg-white p-125">
                <h4 class="font-weight-bold text-primary-darker mb-0"> Event History </h4>
                <p class="text-muted mt-2 mb-0">View the full history of all key events.</p>
                <hr class="bg-gray-400" />
                <FlowEventHistory
                  :flowObjectClass="flowObjectClass"
                  :flowSubtype="flowSubtype"
                  :flowObjectId="flowObjectId"
                  showOpposite
                ></FlowEventHistory>
              </div>
            </div>

            <div
              v-else-if="activeTab === messagesTabKey && enableMessages"
              key="messagesTab"
              class=""
            >
              <div class="mb-5 shadow-sm border rounded-lg bg-white p-125">
                <!-- <h4 class="font-weight-bold text-primary-darker mb-0">
                                  Messages
                              </h4>
                              <hr class="bg-gray-400"> -->
                <div class="pb-3">
                  <base-message-thread
                    v-if="flowObject.message_thread_id"
                    :thread-id="flowObject.message_thread_id"
                    :title="finalMessagesTabName"
                    :subtitle="$t('flowObjectDetail.messagesAreaSubtitle')"
                    create-verb="New"
                    message-name="message"
                    editor-style="rich"
                    thread-type="email"
                    @unread-status="handleMsgThreadUnreadStatus"
                  ></base-message-thread>
                  <!-- TODO add @updated or other event handlers here -->
                  <!-- title-badge-text="External"
                                      title-badge-variant="soft-danger"
                                      title-badge-class="text-uppercase ml-2" -->
                </div>
              </div>
            </div>

            <div
              v-else-if="activeTab === aiAgentTabKey && enableAiAgentTab"
              key="aiAgentTab"
              class=""
            >
              <div class="mb-5 shadow-sm border rounded-lg bg-white p-125">
                <h4 class="font-weight-bold text-primary-darker mb-0">AI Assistant</h4>
                <p class="text-muted mt-2 mb-0">Conversation is specific to you and this workflow.  The AI Assistant can make mistakes, please check its responses.</p>
                <hr class="bg-gray-400" />
                <iframe 
                  :src="aiAgentConfig.iframe_url" 
                  width="100%"
                  height="1000"
                  frameborder="0"
                ></iframe>
              </div>
            </div>

            <div
              v-else-if="allNodeKeys.includes(activeTab)"
              :key="activeTaskKey"
              class="spl-flow-task-active"
            >
              <!-- <b-link @click="handleSummaryClick">&larr; Back to Summary</b-link> -->
              <FlowNode
                :flowObjectClass="flowObjectClass"
                :flowSubtype="flowSubtype"
                :flowObjectId="flowObjectId"
                :nodeKey="activeTaskKey"
                :nodeData="activeTask"
                :flowContext="flowContext"
                @updated="handleTaskUpdated(activeTaskKey)"
                @transition-completed="handleTaskTransitionCompleted"
              ></FlowNode>
            </div>

            <div
              v-else-if="activeTab === transitionMessageTabKey"
              key="transMsgTab"
              class="d-flex align-items-center justify-content-center min-height-500"
            >
              <div
                class="text-center font-weight-600 font-size-120"
                :class="`text-${transitionMessageVariant}`"
              >
                {{ transitionMessage }}
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <b-modal
      v-model="flowTransModalShowing"
      centered
      hide-footer
      @hidden="handleFlowTransModalHidden"
    >
      <div
        v-if="loadingFlowTransDetail"
        key="loadingFlowTransDetail"
        class="w-100"
        style="height: 250px"
      >
        <busy-spinner class="w-100 h-100"></busy-spinner>
      </div>
      <div
        v-else-if="flowTransErrorMsg"
        :key="flowTransErrorMsg"
        class=""
      >
        <b-alert
          variant="warning"
          show
        >
          <h6 class="mb-3 text-center">Oops, there was a problem handling this action.</h6>
          <h5 class="text-center">{{ flowTransErrorMsg }}</h5>
        </b-alert>
        <div class="mt-3 text-right">
          <b-button
            variant="primary"
            @click="handleTransFormCancel"
          >
            Close
          </b-button>
        </div>
      </div>
      <div
        v-else
        key="notLoadingFlowTransDetail"
        class=""
      >
        <h4 class="mb-4">{{ flowTransActive.confirm_title }}</h4>
        <p
          v-for="para in flowTransActive.confirm_description"
          :key="para"
          >{{ para }}</p
        >
        <!-- these collapse if no content -->
        <h5>{{ flowTransFormTitle }}</h5>
        <p>{{ flowTransFormInstructions }}</p>
        <div class="mt-3">
          <FormulateForm
            v-model="flowTransFormData"
            :schema="flowTransFormSchema"
            @submit="handleTransFormSubmit"
            #default="{ isLoading, hasErrors }"
          >
            <div class="mt-5 d-flex justify-content-end gap-3">
              <FormulateInput
                type="button"
                label="Cancel"
                :outer-class="['minimal']"
                @click="handleTransFormCancel"
                :disabled="isLoading"
              />
              <!-- Modal header (and therefore close button) is hidden so we must always show this -->
              <FormulateInput
                type="submit"
                name="submit"
                :label="isLoading ? 'Loading...' : flowTransActive.confirm_button_text || flowTransActive.label"
                :disabled="isLoading || hasErrors"
              />
            </div>
          </FormulateForm>
        </div>
      </div>
    </b-modal>

    <!-- SIDEBAR FOR EVENT HISTORY - use v-b-toggle.event-history-sidebar or v-model with 'visible' prop -->
    <!-- <b-sidebar 
              id="event-history-sidebar" 
              right
              width="600px"
              shadow
              lazy
          >
              <div class="px-4 py-3">
                  <FlowEventHistory
                      :flow-object-id="flowObjectId"
                  ></FlowEventHistory>
              </div>
          </b-sidebar> -->
  </div>
</template>

<script>
  import { errorHandling, currentUserInfoMixin } from '@/js/custom-vue-mixins';
  import { getFlowObjectApi } from '@/js/api-service';
  import { FormatDateTimeLocal } from '@/js/filters-helpers';
  //import invoke from 'lodash/invoke';
  import cloneDeep from 'lodash/cloneDeep';
  import throttle from 'lodash/throttle';
  import sortBy from 'lodash/sortBy';
  import FlowObjectTeamList from '@/components/flows/components/flow_object_team_list/FlowObjectTeamList.vue';
  import FlowNode from './FlowNode.vue';
  import FlowEventHistory from './FlowEventHistory.vue';
  import FlowObjectFileList from '@/components/flows/components/FlowObjectFileList.vue';
  import FlowObjectStateBadge from '@/components/flows/components/FlowObjectStateBadge.vue';
  import { sharedFlowObjectMessages } from '@/localization/shared/flowObjects';
  import AiIcon from '@/components/icons/AiIcon.vue';

  export default {
    name: 'FlowObjectDetail',
    components: {
      FlowObjectTeamList,
      FlowObjectFileList,
      FlowNode,
      FlowEventHistory,
      FlowObjectStateBadge,
      AiIcon,
    },
    mixins: [errorHandling, currentUserInfoMixin],
    i18n: {
        messages: sharedFlowObjectMessages,
    },
    props: {
      flowObjectClass: {
        type: String,
        required: true,
      },
      flowSubtype: {
        type: String,
        default: null,
      },
      flowObjectId: {
        type: String,
        required: true,
      },
      hideTabs: {
        type: Boolean,
        default: false,
      },
      tabCols: {
        type: Number,
        default: 3,
      },
      hideHistory: {
        type: Boolean,
        default: false,
      },
      hideMessages: {
        type: Boolean,
        default: false,
      },
      hideTeam: {
        type: Boolean,
        default: false,
      },
      hideFiles: {
        type: Boolean,
        default: false,
      },
      hideHeader: {
        type: Boolean,
        default: false,
      },
      summaryTabName: {
        type: String,
      },
      teamManagerKey: {
        // if we have this, we use the special team manager component to get this specific one, otherwise we fall back to old way
        type: String, // provide it in the template/parent component - pass it using flowdef.frontend_detail_component_props
        required: false,
      },
      fileManagerKey: {
        // if we have this, we use the special file manager component to get this specific one, otherwise we fall back to old way
        type: String, // provide it in the template/parent component - pass it using flowdef.frontend_detail_component_props
        required: false,
      },
      taskGroups: {
        // should be array of objects with {key, label, condensed (optional), ...other config stuff later}
        type: Array,
        default: () => [],
      },
      condensedTasks: {
        // condensed task lists: hide the task descriptions in the left-side task lists, only show titles
        // this is the DEFAULT for all task groups - each taskGroups entry can override it with its own 'condensed' boolean
        type: Boolean, // provide it in the template/parent component - pass it using flowdef.frontend_detail_component_props
        default: false,
      },
      aiAgentConfig: {
        // configuration for AI agent integration
        // include things like iframe_url: http://localhost:5173/demo/northwind/NWM-PPAP-1001/priya
        type: Object,
        // default: () => ({
        //   iframe_url: 'http://localhost:5173/demo/northwind/NWM-PPAP-1001/priya',
        // }),
        required: false,
      },
    },
    data: function () {
      return {
        errorMsg: 'Error',
        error: false,
        loadingDetail: false,
        loadingTransitions: false,
        loadingNodes: false,
        isManualRefreshing: false,
        initialTasksLoaded: false, // set true after first time, then see if there is one assigned to current user
        // MAIN STATE OBJECTS
        flowObject: {}, // flow object DATA from API (just subset of data, no custom_data fields) - we also feed to header!
        transitions: [],
        allNodes: [],
        taskNodes: [],
        taskNodeGroups: [], // we build these up from taskNodes
        summaryNodes: [],
        actionNodes: [],
        headerNodes: [],
        // MANAGING TABS
        summaryTabKey: '__summary__',
        historyTabKey: '__history__',
        messagesTabKey: '__messages__',
        aiAgentTabKey: '__ai_agent__',
        activeTab: '__summary__', // either the summaryTabKey or activeTask.key
        activeTaskKey: '', // change as you change tabs
        activeTask: {}, // swap in/out the active task
        // EXECUTING TRANSITIONS
        loadingFlowTransDetail: false, // specifically when fetching transition to show in modal -- might need to change if/when you have multiple transitions showing at once... like for 'update_forms'
        flowTransModalShowing: false, // v-model to the modal for FLOW transitions
        flowTransActive: {}, // active transition object
        flowTransFormSchema: [],
        flowTransFormData: {},
        flowTransFormTitle: '',
        flowTransFormInstructions: '',
        flowTransErrorMsg: '', // if there is an error getting the transition detail, set a message here
        // TRANSITION SUCCESS MESSAGES
        transitionMessage: '',
        transitionMessageVariant: 'dark',
        defaultTransitionMessageVariant: 'dark',
        transitionMessageTabKey: '__trans_msg__',
        // RELATED ISSUES
        loadingRelatedIssues: false,
        relatedIssues: [], // get from API
        relatedIssuesCurrentPage: 1, // 1-based
        relatedIssuesPerPage: 5, // keep it small
        relatedIssuesFields: [
          { key: 'title', label: 'Item', class: 'w-40' }, // TODO TODO TODO - may not always be 'title'
          { key: 'current_state_def', label: 'Status', class: 'w-30' }, // that's the state def object -- make sure to format as badge
          { key: 'created', label: 'Created On', class: 'w-30', formatter: (value) => FormatDateTimeLocal(value) },
        ],
        customTabRegistry: {}, // stash here keyed by tabName
      };
    },
    computed: {
      // customData() {  // DO NOT US THIS - KEEP EVERYTHING IN NODES FOR VISIBILITY CONTROL  or you must control what is included in serialized data, by user
      //     // providing a default for things that are nested in custom_data
      //     return this.flowObject?.custom_data ?? {};
      // },
      transitionsByZone() {
        // keys are zone names, values are lists of transition objects
        const byZone = {};
        this.transitions.forEach((t) => {
          const tzones = t.zones ?? [];
          tzones.forEach((z) => {
            byZone[z] = byZone[z] || [];
            byZone[z].push(t);
          });
        });
        return byZone;
      },
      allActions() {
        // this is kinda messy combining 2 different things... either standardize their interface w/ mixin, or only use NODES for any user-facing task/transition/thing
        // combine action transitions + action nodes - maybe combine on backend later
        // need common interface for them - title, description, key, icon, color_variant
        // then you have a single method that handles clicking on one, dispatches the right thing
        // they both have 'position' attr - use that at the end to sort
        const actionTrans = this.transitionsByZone?.actions ?? [];
        const actionNodes = this.actionNodes;
        const actions = [];
        actionTrans.forEach((trans) => {
          actions.push({
            key: `_transition_${trans.trigger}`, // namespace it to avoid conflicts with action nodes
            trigger: trans.trigger, // need this for when we call it
            title: trans.label, // transitions have labels, not title
            description: trans.description,
            icon: trans.icon || 'play-fill',
            color_variant: trans.color_variant || 'primary',
            position: trans.position ?? 0,
            transition: { ...trans },
          });
        });
        actionNodes.forEach((node) => {
          actions.push({
            key: node.key,
            trigger: '', // keep blank, that's how you tell difference between nodes and transitions
            title: node.title,
            description: node.description,
            icon: node.icon || 'play-fill',
            color_variant: node.color_variant || 'primary',
            position: node.position ?? 0,
            node: { ...node },
          });
        });
        return sortBy(actions, ['position']);
      },
      actionsTransitions() {
        // the ones to show in sidebar 'Actions' area
        return this.transitionsByZone?.actions ?? [];
      },
      flowTransitionPending() {
        // is there an active transition?  used to block other ones at the same time
        return Boolean(this.flowTransActive?.trigger);
      },
      triggers() {
        // array of all available/possible triggers from transitions - for easy conditional show/hide things
        return this.transitions.map((trans) => trans.trigger);
      },
      isInFinalState() {
        // is the flow in a final state?  like closed, etc... check some attribute on state dict
        const stateData = this.flowObject.current_state_def ?? {};
        return stateData.is_final_state ?? false;
      },
      flowContext() {
        // the main context object to pass down to descendants - might need watch/deep instead...
        return {
          nodes: this.taskNodes,
          transitions: this.transitions,
          triggers: this.triggers,
          startTransition: this.startTransition, // start one, show modal first - async - must await it!
          callTransition: this.callTransition, // only use this if you specifically want to bypass the modal (team add/remove)
          flowObject: this.flowObject,  // the flow object DATA, partial -- no custom fields - but try to eliminate this, get things through flow object 'store' methods
          toSummary: this.handleSummaryClick, // pass this down so you can call toSummary() from children and go back there
          isInFinalState: this.isInFinalState,
        };
      },
      allNodeKeys() {
        return this.allNodes.map((t) => t.key);
      },
      enableHistory() {
        // is viewing of event history enabled?  return boolean
        return !this.hideHistory;
      },
      enableMessages() {
        // is viewing of messages enabled?  return boolean.  base this on whether flow object has message thread
        return !this.hideMessages;
      },
      enableAiAgentTab() {
        // is the AI Agent tab enabled? return boolean
        // TODO - get this from flow object settings or user permissions
        return this.aiAgentConfig && !!this.aiAgentConfig.enabled;
        // return true;  // !this.hideAiAgentTab;
      },
      hasUnreadMessages() {
        // change this logic later to pull from a central message thread store
        // this allows you to get rid of the flowObject data (retrieve endpoint)
        return this.flowObject?.message_thread_read_status?.has_unread ?? false;
      },
      flowObjectApi() {
        return getFlowObjectApi(this.flowObjectClass, this.flowSubtype);
      },
      customTabNames() {
        return Object.keys(this.customTabRegistry);
      },
      slotData() {
        /// return object of stuff to pass to scoped slots
        return {
          flowContext: this.flowContext,
        };
      },
      detailCols() {
        // how many columns to use for detail area, based on tabCols prop - returns a string to use in template
        if (!this.hideTabs && this.tabCols && typeof this.tabCols === 'number' && this.tabCols < 12) {
          return String(12 - this.tabCols);
        }
        return 'auto'; // should work if hideTabs === true or if not
      },
      finalSummaryTabName() {
        return this.summaryTabName || this.$t('flowObjectDetail.summaryTabName');
      },
      finalHistoryTabName() {
        return this.$t('flowObjectDetail.historyTabName');
      },
      finalMessagesTabName() {
        return this.$t('flowObjectDetail.messagesTabName');
      },
      tasksLabel() {
        return this.$t('flowObjectDetail.tasksLabel');
      },
      actionsLabel() {
        return this.$t('flowObjectDetail.actionsLabel');
      },
    },
    created() {
      // we don't need to call throttled version everywhere, but makes sense from task updates
      // we will trigger it on leading edge, so it should still happen immediately
      this.throttledRefresh = throttle(this.refresh, 2000, { leading: true, trailing: true }); // in case we have lots of form updating all at once, like on initial load of a form task
    },
    mounted() {
      this.getDetail();
      this.getNodes();
      this.getTransitions();
      this.getRelatedIssues();
      // populate custom tab registry
      const customTabNodes = this.$scopedSlots.customtabs ? this.$scopedSlots.customtabs().filter((vn) => !!vn.componentInstance?.$data?.isFlowObjectCustomTab) : [];
      // looking for our special components
      // go through all the VNodes -- find the right ones, then register the componentOptions objects -- we use that to dyanmically show in <component :is=""> component
      customTabNodes.forEach((n) => {
        const compOptions = n.componentOptions; // will only have this if not showing
        const compInstance = n.componentInstance;
        const tabName = compOptions?.propsData?.name;
        const customTab = {
          name: tabName,
          title: compOptions?.propsData?.title,
          description: compOptions?.propsData?.description || '',
          icon: compOptions?.propsData?.icon || 'record-fill',
          component: compInstance,
        };
        //const compUid = n.componentInstance?._uid;
        //const tabName = n.componentInstance?.$props?.name;
        if (tabName && compInstance) {
          this.$set(this.customTabRegistry, tabName, customTab);
        }
      });
    },
    methods: {
      // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
      refresh() {
        // refresh all the things... no await here
        console.log('refreshing all the things on FlowObjectDetail');

        // TODO - fix this so you don't exceed browser limits in one parallel call!
        return Promise.all([this.getDetail(), this.getNodes(), this.refreshFileList(), this.getTransitions(), this.getRelatedIssues()]);
      },
      refreshFileList() {
        // Refresh file list if present
        if (this.$refs.fileList && typeof this.$refs.fileList.refresh === 'function') {
          this.$refs.fileList.refresh();
        }
      },
      async getDetail() {
        // TODO - try to eliminate this!  get things from various store methods on the flowObject.js
        this.loadingDetail = true;
        // NOT NEEDED const previousSmState = this.flowObject?.sm_state;
        let resp;
        try {
          resp = await this.flowObjectApi.retrieve(this.flowObjectId);
        } catch (error) {
          this.apiErrorHandler(error);
        }
        if (resp?.data) {
          this.flowObject = resp.data;
        }
        /* NO LONGER NEEDED const newSmState = this.flowObject?.sm_state;
              if (newSmState === 'closed' && Boolean(previousSmState) && newSmState !== previousSmState) {
                  // reload the page if we just closed the flowObject - maybe more graceful later
                  window.location.reload();
              } */
        this.loadingDetail = false;
      },
      async getRelatedIssues() {
        this.loadingRelatedIssues = true;
        let resp;
        try {
          resp = await this.flowObjectApi.get_related_instances(this.flowObjectId);
        } catch (error) {
          this.apiErrorHandler(error);
        }
        if (resp?.data) {
          this.relatedIssues = resp.data; // not paginated
        }
        this.loadingRelatedIssues = false;
      },
      async getTransitions() {
        this.loadingTransitions = true;
        let resp;
        try {
          resp = await this.flowObjectApi.get_possible_transitions(this.flowObjectId);
        } catch (error) {
          this.apiErrorHandler(error);
        }
        if (resp?.data) {
          this.transitions = resp.data;
        }
        this.loadingTransitions = false;
      },
      async getNodes() {
        this.loadingNodes = true;
        let resp;
        try {
          resp = await this.flowObjectApi.get_visible_nodes(this.flowObjectId);
        } catch (error) {
          this.apiErrorHandler(error);
        }
        if (resp?.data) {
          this.setLocalNodes(resp.data);
        }
        this.loadingNodes = false;
      },
      setLocalNodes(apiNodes) {
        // build local list from api list - also split tasks/nodes into different types based on where/how displayed
        const allNodes = [];
        apiNodes.forEach((n) => {
          // console.log('apiNode.key:', n.key);  // n.key here IS the combined key (with subkey)
          // add some extra attrs (mutates them) - ok to do since incoming data is fresh from API call
          const isAssignedTu = (!!n.assigned_tus && n.assigned_tus.map((atu) => atu.id).includes(this.$currentUserInfo.tenant_user_id)) || false;
          n['isAssignedTu'] = isAssignedTu;
          n['showIsAssignedTu'] = n.isAssignedTu && n.is_active;
          const isSupplierTask = !!n.assigned_tus && n.assigned_tus.some((atu) => atu.is_external);
          n['showSupplierTaskBadge'] = isSupplierTask && !isAssignedTu && n.is_active; // only show for active tasks?
          allNodes.push(n);
        });
        // now split them into groups based on zone (which is based on node type)
        const taskNodes = [];
        const summaryNodes = [];
        const actionNodes = [];
        const headerNodes = [];
        allNodes.forEach((t) => {
          // we allow for one node to be in multiple zones... (for now at least) so don't do if / else if
          if (t.zones.includes('summary')) {
            // display nodes here
            summaryNodes.push(t);
          }
          if (t.zones.includes('tasks')) {
            taskNodes.push({ iconData: this.getTaskNodeIconData(t), ...t });
          }
          if (t.zones.includes('actions')) {
            actionNodes.push(t);
          }
          if (t.zones.includes('header')) {
            headerNodes.push(t);
          }
        });
        this.allNodes = allNodes;
        this.taskNodes = taskNodes;
        this.summaryNodes = summaryNodes;
        this.actionNodes = actionNodes;
        this.headerNodes = headerNodes;

        // HANDLE taskGroups -- if any
        // currently things seem to work OK if a task is in multiple groups... but watch for issues
        // works becuase we have lists update based on the active selection, not always vice versa
        const defaultTaskGroupKey = '_DEFAULT_';
        const providedGroupKeys = this.taskGroups && Array.isArray(this.taskGroups) ? this.taskGroups.map((tg) => tg.key) : [];
        // if you find a groupKey in a node that should otherwise be visible (if its here, it should be visible) but does not have a group in props, we put it in default group
        const taskGroupPrefix = 'tasks:';
        // make an object of task nodes by their group key (or put in _DEFAULT_)
        const taskNodesByGroupKey = {};
        this.taskNodes.forEach((tn) => {
          const taskGroupComboKey = tn.zones.find((z) => z.startsWith(taskGroupPrefix));
          let taskGroupKey = defaultTaskGroupKey; // use this if you don't find 'tasks:something'
          if (taskGroupComboKey) {
            const parsedTaskGroupKey = taskGroupComboKey.replace(taskGroupPrefix, ''); // strip it off
            taskGroupKey = providedGroupKeys.includes(parsedTaskGroupKey) ? parsedTaskGroupKey : defaultTaskGroupKey; // put in default if we don't know about that group from props
          }
          // stash the node in the right group key
          if (taskNodesByGroupKey[taskGroupKey]) {
            taskNodesByGroupKey[taskGroupKey].push(tn);
          } else {
            taskNodesByGroupKey[taskGroupKey] = [tn];
          }
        });
        // always start with the default one so we always show that on top, then add others
        // TODO - what should we do if we have nodes for groups that we don't have specified groups for in props?  put in default?  hide?
        // we'll put them in default for now (that's why we got the list of provided group keys above)
        const taskNodeGroups = []; // only add things here if you have a group in prop, and if you have nodes for them!
        const defaultGroupNodes = taskNodesByGroupKey[defaultTaskGroupKey] || [];
        if (defaultGroupNodes.length) {
          taskNodeGroups.push({ key: defaultTaskGroupKey, label: this.tasksLabel, nodes: defaultGroupNodes, condensed: this.condensedTasks });
        }
        if (this.taskGroups && Array.isArray(this.taskGroups)) {
          this.taskGroups.forEach((tg) => {
            const nodesForGroup = taskNodesByGroupKey[tg.key] || [];
            if (nodesForGroup.length) {
              // per-group 'condensed' wins over the top-level condensedTasks default
              const condensed = typeof tg.condensed === 'boolean' ? tg.condensed : this.condensedTasks;
              taskNodeGroups.push({ key: tg.key, label: tg.label, nodes: nodesForGroup, condensed });
            }
          });
        }
        this.taskNodeGroups = taskNodeGroups;
        // END OF HANDLING TASK GROUPS

        if (!this.initialTasksLoaded) {
          // is this first load?  then automatically go to first assigned task if there is one
          // and set initialTasksLoaded = true;
          this.goToNextAssignedTask();
          this.initialTasksLoaded = true;
        }
      },
      getTaskNodeIconData(tn) {
        // could be is_completed, is_active, is_skipped, or none of them - just a utility
        if (tn.is_completed) {
          return { icon: 'check-circle-fill', variant: 'success', class: 'bg-success-100', tooltip: 'Completed' };
        } else if (tn.is_active) {
          return { icon: 'record-fill', variant: 'primary', class: 'bg-primary-100', tooltip: 'Active' };
        } else if (tn.is_skipped) {
          return { icon: 'x-circle-fill', variant: 'secondary', class: 'bg-secondary-100', tooltip: 'Skipped' };
        } else if (tn.is_expired) {
          return { icon: 'exclamation-triangle-fill', variant: 'warning', class: 'bg-warning-100', tooltip: 'Expired' };
        } else {
          return { icon: 'record-fill', variant: 'secondary', class: 'bg-secondary-100', tooltip: 'Waiting' };
        }
      },
      findNextAssignedTask() {
        // this searches through taskNodes for any active task assigned to current TU
        // if it finds one, it returns it
        // if not found, returns null
        // use this to jump to the next logical task for user after a transition
        const foundTask = this.taskNodes.find((t) => t.showIsAssignedTu);
        return foundTask ? foundTask : null;
      },
      goToNextAssignedTask() {
        const nextTaskForUser = this.findNextAssignedTask(); // returns null if there isn't one
        if (nextTaskForUser) {
          this.handleNodeClick(nextTaskForUser);
        } else {
          this.handleSummaryClick();
        }
      },
      refreshThenGoNext(timeout = 1500) {
        // returns a Promise
        return this.refresh()
          .then(() => {
            // set a minimum timeout?  we'll just put it in here... will get added on the time neede for refresh(), but that should be fast
            setTimeout(() => {
              this.goToNextAssignedTask();
            }, timeout);
          })
          .then(() => {
            return true;
          });
      },
      async manualRefresh() {
        this.isManualRefreshing = true;
        await this.refreshThenGoNext(1);
        this.isManualRefreshing = false;
      },
      // TAB NAVIGATION
      clearActiveTask() {
        // util to call from other navigation methods
        this.activeTaskKey = '';
        this.activeTask = {};
      },
      handleSummaryClick() {
        // go to summary
        console.log('go to summary');
        this.clearCustomTabs();
        if (this.activeTab !== this.summaryTabKey) {
          // if you're actually changing...
          // NOTE - may want to refresh some things here, since you turned off refresh on any task update
          // at least files may be stale... maybe other things too
          this.activeTab = this.summaryTabKey;
          this.refreshFileList();  // NOTE BY MH: might not need this here, since it is now in a component that gets destroyed/recreated, but should be safe to call anyways
          this.getRelatedIssues(); // move to separate component... let it refresh itself
        }
        this.clearActiveTask(); // we can do this no matter what
      },
      handleHistoryClick() {
        this.clearCustomTabs();
        // go to history tab
        this.activeTab = this.historyTabKey;
        this.clearActiveTask();
        // history component will handle its own state/fetching
      },
      handleMessagesClick() {
        this.clearCustomTabs();
        this.activeTab = this.messagesTabKey;
        this.clearActiveTask();
        // messages component will handle itself
      },
      handleAiAgentTabClick() {
        this.clearCustomTabs();
        this.activeTab = this.aiAgentTabKey;
        this.clearActiveTask();
      },
      clearCustomTabs(exceptTabName) {
        // exceptTabName is optional
        Object.entries(this.customTabRegistry).forEach(([tabName, customTab]) => {
          if (tabName !== exceptTabName) {
            customTab.component.localActive = false;
          }
        });
      },
      handleCustomTabClick(tabName) {
        console.log('custom tab clicked: ', tabName);
        this.clearCustomTabs(tabName);
        //const compUid = this.customTabRegistry[tabName];
        const customTab = this.customTabRegistry[tabName];
        customTab.component.localActive = true;
        this.activeTab = tabName;
        this.clearActiveTask();
      },
      handleNodeClick(task) {
        console.log('clicked task', task);
        this.clearCustomTabs();
        this.activeTaskKey = task.key;
        this.activeTask = { ...task };
        this.activeTab = this.activeTaskKey;
      },
      handleActionClick(action) {
        // actions could be action nodes OR flow transitions - common interface
        if (action.trigger) {
          // then we have a TRANSITION - dispatch that
          this.startTransition(action.trigger); // this is async, but proabably don't need to await it here...
        } else {
          // then we have an action NODE - change to that 'tab'
          this.handleNodeClick(action.node);
        }
      },
      showTransitionMessage({ message, variant }) {
        // set things for the transition message, then switch to that tab
        if (!message) {
          return;
        }
        this.transitionMessage = message;
        this.transitionMessageVariant = variant || this.defaultTransitionMessageVariant;
        this.activeTab = this.transitionMessageTabKey;
        this.clearActiveTask();
      },
      clearTransitionMessage() {
        // clear the transition message, maybe not completely necessary if you always reset it when showing a new one?
        this.transitionMessage = '';
        this.transitionMessageVariant = this.defaultTransitionMessageVariant;
      },

      // TRANSITIONS
      canTrigger(triggerName) {
        return this.triggers.includes(triggerName);
      },
      async startTransition(triggerName) {
        console.log('clicked transition trigger', triggerName);
        if (this.flowTransitionPending) {
          this.$toast.warning('Another action is currently pending. Try later.');
          return;
        }
        this.resetTransition(); // start with a clean slate, including flowTransErrorMsg

        // TODO - if you are modifying things on the instance in these transitions
        // then you should fetch the transition form here, with initial data included
        // do it here(ish), just before showing the form
        // ALSO, if no confirm_title, confirm_description, or form, then go straight to call_transition

        // ADDING FETCHING OF FRESH TRANSITION OBJECT VIA API - Oct 8 2023
        this.loadingFlowTransDetail = true;
        this.flowTransModalShowing = true; // show the modal just before we make API call (but after we set loading = true) to make it seems more snappy
        let transDetailResp;
        try {
          transDetailResp = await this.flowObjectApi.get_transition_detail(this.flowObjectId, triggerName);
        } catch (error) {
          // you return a 409 if this is no longer available, or multiple transitions available with same trigger name
          // for now we'll just swallow it, log it, and show warning with message content -- if its a 409
          let errMsg = 'There was a problem fetching the transition details'; // default... change below based on error type
          if (error.response?.status == 409) {
            console.error(`Got error while trying to fetch transition detail for trigger name ${triggerName}`);
            console.error(error);
            errMsg = error.response?.data || 'This action is no longer available';
            // this.$toast.warning(errMsg);  // skip the toast for now, just show in modal instead
          } else {
            this.apiErrorHandler(error);
          }
          this.flowTransErrorMsg = errMsg; // set the error message to show in modal, and to skip the other stuff below
        }
        if (transDetailResp && transDetailResp.data && !this.flowTransErrorMsg) {
          const transObj = transDetailResp.data;

          this.flowTransActive = Object.freeze(Object.assign({}, transObj)); // we were doing Object.freeze() when we were getting it from local store, but probably not really needed...

          // CHANGED STRUCTURE, now using same form structure as other form nodes
          // COMBINE THESE INTO A SINGLE OBJECT?  MAKE THEM COMPUTEDS?
          this.flowTransFormTitle = this.flowTransActive.form?.form?.title || '';
          this.flowTransFormInstructions = this.flowTransActive.form?.form?.instructions || '';
          this.flowTransFormData = this.flowTransActive.form?.data ? cloneDeep(this.flowTransActive.form.data) : {};
          this.flowTransFormSchema = this.flowTransActive.form?.form?.items ? cloneDeep(this.flowTransActive.form?.form?.items) : []; // form.form has {title, instructions, items}
        }
        // need an else block here?  only way we should not have it is if we got error in handling the response data above... or else we'd end up in catch block
        this.loadingFlowTransDetail = false;
        /*
              const transObj = this.transitions.find(trans => (trans.trigger === triggerName));
              if (!transObj) {
                  console.error(`Tried calling transition trigger ${triggerName} but it is not a valid option`);
                  this.$toast.warning('This action is no longer an option');
                  return;
              }
              this.flowTransActive = Object.freeze(Object.assign({}, transObj));  // freeze it -- this we can always pull from here -- until we replace it on reset
              
              // CHANGED STRUCTURE, now using same form structure as other form nodes
              // COMBINE THESE INTO A SINGLE OBJECT?  MAKE THEM COMPUTEDS?
              this.flowTransFormTitle = this.flowTransActive.form?.form?.title || '';
              this.flowTransFormInstructions = this.flowTransActive.form?.form?.instructions || '';
              this.flowTransFormData = this.flowTransActive.form?.data ? cloneDeep(this.flowTransActive.form.data) : {};
              this.flowTransFormSchema = this.flowTransActive.form?.form?.items ? cloneDeep(this.flowTransActive.form?.form?.items) : [];  // form.form has {title, instructions, items}
              */

        // TODO - allow for not showing the confirm modal on some?

        // should we show the modal BEFORE we make API call?  if not, might seem like a long delay, non-responsive UI
        /* this.$nextTick(() => {
                  this.flowTransModalShowing = true;
              }); */
      },
      resetTransition() {
        // utility to reset everything related to transition
        this.flowTransModalShowing = false; // probably already closed, but anyways
        this.flowTransFormData = {};
        this.flowTransFormSchema = [];
        this.flowTransFormTitle = '';
        this.flowTransFormInstructions = '';
        this.flowTransActive = {};
        this.flowTransErrorMsg = '';
      },
      handleFlowTransModalHidden() {
        // reset things
        this.resetTransition();
      },
      handleTransFormCancel() {
        this.flowTransModalShowing = false; // close it, then the @hidden event will reset things
      },
      async handleTransFormSubmit(submitData) {
        // make sure this is async since we call it from @submit event of formulate form, which expects an async function to show loading, make sure uploads complete, etc.
        console.log('submitData from transition', submitData);
        await this.callTransition(this.flowTransActive, submitData);
      },
      async callTransition(transObj, collectData) {
        console.log('HELLO FROM callTransition');
        // pass in 2 args -- 1) full transition object and 2) any collectData we gathered, if required
        // do we need to prep collectData for sending??? set defaults?  change types???
        // need to put things into one object as backend is expecting
        const finalCollectData = collectData ? { ...collectData } : {};
        const triggerData = {
          trigger: transObj.trigger,
          ...finalCollectData,
        };
        this.loadingTransitions = true;
        let respData = {}; // object we'll pass to handleStateChange() - just a default
        try {
          const resp = await this.flowObjectApi.call_transition(this.flowObjectId, triggerData);
          // successful?  emit something to parent to refresh?  just set respData, then handle at the end
          respData = resp?.data || {};
          // {  // standard response from DWF transitions as of Oct 4 2022
          //     success (bool),
          //     message (string),
          //     object (serialized object being transitioned, maybe with sparse fields),
          //     redirect_url, (optional, added Oct 4 2022),
          // }
          // don't change what you pass up here unless you do it for ALL things that use this component, because they may have other things that call methods with same signature/params
        } catch (err) {
          console.log('got an error - below'); // so we can see things in RUM tracking
          console.log(err);
          console.log(typeof err);
          console.log(err.toJSON());
          // err.response is where all the good stuff is:  { config, data, headers, request, status, statusText }
          if (err.response?.status === 403) {
            // if we got 403, either we have someone trying to do bad things, or the state just got updated and that transition is no longer available (this has actually happened)
            this.$toast('That action is no longer available.  Try refreshing the page, then try again.');
          } else {
            this.apiErrorHandler(err, 'Error while processing this.  Please contact Supplios support.');
          }
        }
        this.loadingTransitions = false; // although we might want to refresh right away?
        this.flowTransModalShowing = false;
        // TODO - figure out what to do next... show success message?  redirect?
        if (respData.success && respData.message) {
          this.$toast.success(respData.message);
        }
        this.refresh();
        // maybe don't go next automatically for these transitions?  let's see...
        //this.refreshThenGoNext(1);
        // this.stateChangeComplete = true;  // must do this before closing modal so we know NOT to emit 'cancel' event
        // this.collectDataModal = false;
        // // originally had handleStateChange in try block, but moving here... will do it before stopping loading state?
        // this.handleStateChange(respData);  // this could trigger a redirect if we have redirect_url
        // this.handleLoadingState(false);
        // RETURN ANYTHING HERE?  child components might call this (like team list)
      },

      // HANDLING TASK EVENTS
      handleTaskUpdated(nodeKey) {
        // called from any state update on a task/node
        // we should refresh things -- but keep the same active task? maybe depends on what tab we're on?
        // TURNING THIS OFF FOR NOW - ONLY REFRESH ON ACTUAL TRANSITIONS OTHERWISE THIS IS VERY VERY ANNOYING
        // this.throttledRefresh();  // this.refresh();
        console.log('node updated - node key:', nodeKey);
      },
      handleTaskTransitionCompleted(transCompletedPayload) {
        // called on ANY task transition completed
        // show success message, then go to the tab for the nodeKey provided, if any, or summary
        const { success, message } = transCompletedPayload; // also has: nodeKey
        const msgVariant = success ? 'success-darker' : 'dark';
        this.showTransitionMessage({ message: message, variant: msgVariant });
        // then call refresh on things in the background while message is showing
        this.refreshThenGoNext(1500);
        // this.refresh().then(() => {
        //     // set a minimum timeout?  we'll just put it in here... will get added on the time neede for refresh(), but that should be fast
        //     setTimeout(() => {
        //         this.goToNextAssignedTask();
        //     }, 1500);
        // });
      },
      // MESSAGES
      handleMsgThreadUnreadStatus(payload) {
        console.log('handleMsgThreadUnreadStatus', payload); // not sure what this will be...
      },
    },
  };
</script>

<style lang="scss">
  .flow-object-detail {
    // added this top-level class later... could probably put all things in its scope...
    .task-node-group {
      margin-bottom: 1rem;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .flow-object-tabs {
    // background-color: var(--primary);  // to give it a backdrop color when they shift on hover
    // doesn't look good with border on items -- which is needed in case layout goes horizontal, let bootstrap css manage it

    .flow-object-tab-item {
      transition: background-color 0.15s, transform 0.15s;
      background-color: var(--gray-50);
      .tab-icon {
        border-left: 4px solid transparent;
        border-left-color: transparent;
        transition: border-left-color 0.3s;
      }
      &.active {
        background-color: #fff;
        border-color: var(--gray-200);
        box-shadow: $box-shadow-sm;
        .tab-icon {
          border-left-color: var(--primary);
        }
      }
      &:hover {
        //transform: scale(1.01);
        //transform: scale(1.01) translateX(4px);
        background-color: #fff;
        transform: translateX(2px);
      }

      .special-task-assignee-badge {
        // common for multiple similar badges
        position: absolute;
        left: -2px;
        padding: 2px 4px 1px 4px;
        font-weight: 700;
        font-size: 0.6rem;
        text-transform: uppercase;
        border-width: 1px 1px 1px 0;
        border-style: solid;
        border-color: transparent;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;

        &.is-assigned-tu-badge {
          top: 4px;
          color: var(--danger-600);
          background-color: var(--danger-100);
        }
        &.supplier-flow-task-badge {
          top: 2px;
          color: var(--secondary-700);
          background-color: var(--secondary-100);
          border-color: var(--secondary-200);
        }
      }
    }
  }

  /* TRANSITION STYLES */
  .flow-object-active-node-trans-enter-active {
    transition: opacity 0.3s ease, transform 0.3s; // 0.15s ease-in 0.15s;
  }
  .flow-object-active-node-trans-enter {
    // transform: scale(0.95);  // apparently these are not good for accessibility
    //transform: translateX(-5px);  // translates are annoying
    transform: translateY(8px);
    opacity: 0;
  }
  // WE NOW FADE OUT INSTANTLY SO WE CAN HANDLE CUSTOM TABS
  // .flow-object-active-node-trans-leave-active {
  //     //transition: opacity 0.3s ease, transform 0.3s;  // 0.15s ease-in 0.15s;
  // }
  // .flow-object-active-node-trans-leave-to  {
  //     // transform: scale(0.95);
  //     //transform: translateX(-5px);
  //     //transform: translateY(8px);
  //     //opacity: 0;
  // }
</style>
